/* YNY — interacțiuni. Totul funcționează și fără JS (formularele trimit normal). */
(function () {
  'use strict';
  var T = window.theme || {};

  function $(s, root) { return (root || document).querySelector(s); }
  function $$(s, root) { return Array.prototype.slice.call((root || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} lei';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }
  T.formatMoney = formatMoney;

  /* Bandă de anunț */
  $$('[data-announce]').forEach(function (el) {
    var msgs = $$('.announce__msg', el);
    if (msgs.length < 2) return;
    var i = 0;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    $('[data-prev]', el).addEventListener('click', function () { show(i - 1); });
    $('[data-next]', el).addEventListener('click', function () { show(i + 1); });
    setInterval(function () { if (!el.matches(':hover')) show(i + 1); }, 5000);
  });

  /* Mega-meniu */
  $$('[data-mega-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open);
      panel.classList.toggle('is-open', open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (btn.getAttribute('aria-expanded') === 'true' && !panel.contains(e.target) && !btn.contains(e.target)) btn.click();
    });
  });

  /* Meniu mobil */
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { var m = $('[data-menu]'); if (m) { m.classList.add('is-open'); var f = $('a', m); if (f) f.focus(); } });
  });
  $$('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { var m = $('[data-menu]'); if (m) m.classList.remove('is-open'); });
  });

  /* File de produse (homepage) */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
  });

  /* Bară de progres pentru rânduri care derulează */
  $$('[data-scroll-row]').forEach(function (row) {
    var bar = row.parentElement.querySelector('.progress__bar');
    if (!bar) return;
    function upd() {
      var max = row.scrollWidth - row.clientWidth;
      var vis = row.clientWidth / row.scrollWidth;
      bar.style.width = Math.max(10, vis * 100) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 / vis) - 1) * 100 : 0) + '%)';
    }
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* Bară livrare gratuită */
  function paintShip(root, cents) {
    if (!root) return;
    var limit = T.freeShipping || 0;
    if (!limit) { root.hidden = true; return; }
    var left = limit - cents;
    var msg = $('[data-ship-msg]', root);
    var bar = $('[data-ship-bar]', root);
    if (msg) msg.textContent = left > 0 ? root.getAttribute('data-left').replace('[amount]', formatMoney(left)) : root.getAttribute('data-done');
    if (bar) bar.style.width = Math.min(100, Math.round((cents / limit) * 100)) + '%';
  }
  T.paintShip = paintShip;

  /* Pagina de produs: pachete */
  $$('[data-product]').forEach(function (root) {
    var form = $('form[data-product-form]', root);
    var ship = $('[data-ship]', root);
    var atcPrice = $('[data-atc-price]', root);
    var badge = $('[data-main-badge]', root);
    function current() { return $('input[name="id"]:checked', root); }
    function apply() {
      var input = current();
      if (!input) return;
      var price = parseInt(input.getAttribute('data-price'), 10) || 0;
      if (atcPrice) atcPrice.textContent = formatMoney(price);
      paintShip(ship, price);
      if (badge) {
        var s = input.getAttribute('data-save');
        badge.hidden = !s;
        if (s) badge.textContent = '−' + s + '%';
      }
      var atc = $('[data-atc]', root);
      if (atc) atc.disabled = input.hasAttribute('data-soldout');
      var media = input.getAttribute('data-media');
      if (media) showMedia(root, media);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('input[name="id"]', root).forEach(function (i) { i.addEventListener('change', apply); });
    $$('[data-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () { showMedia(root, b.getAttribute('data-thumb')); });
    });
    apply();
  });

  function showMedia(root, id) {
    var main = $('[data-main-img]', root);
    var thumb = $('[data-thumb="' + id + '"]', root);
    if (!main || !thumb) return;
    var img = $('img', thumb);
    main.src = img.getAttribute('data-full') || img.src;
    main.srcset = '';
    main.alt = img.alt;
    $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }

  /* Coș: adăugare, deschidere, actualizare */
  var drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('drawer-open');
    var c = $('[data-cart-close]', drawer);
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('drawer-open');
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    var id = drawer.getAttribute('data-section-id');
    return fetch(T.routes.root + '?section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-panel]');
        var panel = $('[data-cart-panel]', drawer);
        if (fresh && panel) panel.innerHTML = fresh.innerHTML;
        var count = parseInt((doc.querySelector('[data-cart-count-value]') || {}).textContent || '0', 10);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
        bindDrawer();
      });
  }
  T.refreshCart = refreshDrawer;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function bindDrawer() {
    if (!drawer) return;
    $$('[data-cart-close]', drawer).forEach(function (b) { b.onclick = closeDrawer; });
    $$('[data-line-change]', drawer).forEach(function (b) {
      b.onclick = function () {
        b.disabled = true;
        post(T.routes.cartChange + '.js', { line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) })
          .then(refreshDrawer).catch(function () { b.disabled = false; });
      };
    });
    $$('[data-quick-add]', drawer).forEach(function (b) {
      b.onclick = function () {
        b.disabled = true;
        post(T.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }] })
          .then(refreshDrawer).catch(function () { b.disabled = false; });
      };
    });
    $$('[data-upsell]', drawer).forEach(function (b) {
      b.onclick = function () {
        b.disabled = true;
        post(T.routes.cartChange + '.js', { line: parseInt(b.getAttribute('data-line'), 10), quantity: 0 })
          .then(function () { return post(T.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }] }); })
          .then(refreshDrawer).catch(function () { b.disabled = false; });
      };
    });
  }

  if (drawer) {
    bindDrawer();
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refreshDrawer().then(openDrawer); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(refreshDrawer)
        .then(openDrawer)
        .catch(function (err) {
          var box = form.querySelector('[data-form-error]');
          if (box) { box.hidden = false; box.textContent = (err && (err.description || err.message)) || 'Nu am putut adăuga produsul.'; }
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* Ofertă înainte de plată: adaugă produsul, aplică codul, merge la plată */
  $$('[data-offer-accept]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      var code = b.getAttribute('data-code');
      post(T.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }] })
        .then(function () { window.location.href = (code ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/checkout'); })
        .catch(function () { b.disabled = false; window.location.href = '/checkout'; });
    });
  });

  /* Pagina de coș: salvează nota și cantitățile, apoi merge la ofertă */
  $$('[data-offer-go]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      b.disabled = true;
      var dest = b.value;
      fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(b.form) })
        .then(function () { window.location.href = dest; })
        .catch(function () { window.location.href = dest; });
    });
  });

  /* „Se potrivește cu”: adaugă produsul și deschide coșul */
  $$('[data-pair-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      post(T.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-pair-add'), 10), quantity: 1 }] })
        .then(function () { b.textContent = 'Adăugat ✓'; return refreshDrawer(); })
        .then(openDrawer)
        .catch(function () { b.disabled = false; });
    });
  });

  /* Butoane „Copiază codul” */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var label = $('[data-copy-label]', b);
      var done = function () { if (label) { label.textContent = 'Copiat ✓'; setTimeout(function () { label.textContent = 'Copiază'; }, 2000); } };
      if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy')).then(done, done); else done();
    });
  });

  /* Bara fixă de cumpărare: apare când butonul principal iese din ecran */
  var stickyBuy = document.querySelector('[data-sticky-buy]');
  var buyBox = document.querySelector('[data-product] form[action*="/cart/add"]') || document.getElementById('produs');
  if (stickyBuy && buyBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0];
      stickyBuy.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      document.body.classList.toggle('has-sticky-buy', !stickyBuy.hidden);
    }).observe(buyBox);
  }

  /* Video-urile decorative nu pornesc singure la cine a cerut mai puțină mișcare */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('.pd-reveal video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  /* Animații la intrarea în ecran (o singură dată; CSS-ul respectă „reduce motion”) */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { threshold: 0.25 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Recomandări de produse */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.closest('section').hidden = true;
    });
  });

  /* Preferințe cookie: butonul apare doar dacă bannerul de cookie Shopify e activ */
  var cookieBtn = $('[data-cookie-prefs]');
  if (cookieBtn) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        cookieBtn.hidden = false;
        cookieBtn.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
        clearInterval(t);
      } else if (tries > 20) { clearInterval(t); }
    }, 500);
  }

  /* Newsletter: apare discret, o singură dată la N zile */
  var pop = $('[data-nl]');
  if (pop) {
    var tab = $('[data-nl-tab]');
    var KEY = 'yny-nl-dismissed';
    var days = parseInt(pop.getAttribute('data-days'), 10) || 14;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 15) * 1000;
    var scrollPct = parseInt(pop.getAttribute('data-scroll'), 10) || 40;
    var forced = pop.hasAttribute('data-force-open');
    var shown = false;
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* stocare indisponibilă */ } }
    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function dismissedRecently() {
      var t = parseInt(read() || '0', 10);
      return t && (Date.now() - t) < days * 864e5;
    }
    function show() {
      if (shown) return;
      shown = true;
      pop.classList.add('is-open');
      if (tab) tab.classList.remove('is-visible');
    }
    function hide() {
      pop.classList.remove('is-open');
      store(String(Date.now()));
      if (tab && !pop.hasAttribute('data-done')) tab.classList.add('is-visible');
    }
    $$('[data-nl-close]', pop).forEach(function (b) { b.addEventListener('click', hide); });
    if (tab) tab.addEventListener('click', function () { shown = false; show(); });
    $$('[data-open-newsletter]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); shown = false; show(); var f = $('input[type="email"]', pop); if (f) f.focus(); });
    });
    if (forced) { show(); }
    else if (dismissedRecently() || pop.hasAttribute('data-subscribed')) { if (tab && !pop.hasAttribute('data-subscribed')) tab.classList.add('is-visible'); }
    else {
      setTimeout(show, delay);
      window.addEventListener('scroll', function onS() {
        var h = document.documentElement;
        if ((h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) * 100 >= scrollPct) { show(); window.removeEventListener('scroll', onS); }
      }, { passive: true });
    }
  }
})();
